import { Tab, Tabs } from '@material-ui/core';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import React, { useCallback, useEffect, useState } from 'react';
import { Switch, useHistory, useLocation } from 'react-router-dom';
import ManagementPanel from '../../pages/PersonnelDepartmentPanel/ManagementPanel';
import PersonnelDepartmentOverview from '../../pages/PersonnelDepartmentPanel/Overview';
import PunchCardObservations from '../../pages/PersonnelDepartmentPanel/PunchCardObservations';
import SendingNotices from '../../pages/PersonnelDepartmentPanel/SendingNotices';
import { isAuthenticatedFromGDP } from '../../store/actions/authActions';
import Route from '../Route';
import { RouteItem, ROUTES } from '../routes';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    tabsContainer: {
      backgroundColor: theme.palette.primary.main,
      color: theme.palette.primary.contrastText,
      minHeight: 36,
      paddingLeft: theme.spacing(3),
      paddingRight: theme.spacing(3),
    },
    tabContent: {
      minHeight: 36,
      textTransform: 'none',
    },
  }),
);

const PersonnelDepartmentPanelNavigation: React.FC = () => {
  const classes = useStyles();
  const location = useLocation();
  const history = useHistory();
  const [personnelDepartmentRoutes, setPersonnelDepartmentRoutes] = useState<
    RouteItem[]
  >([]);
  const [tabSelected, setTabSelected] = useState(() => {
    const routeIndex = personnelDepartmentRoutes.findIndex(item =>
      location.pathname.includes(item.path),
    );

    return routeIndex === -1 ? 0 : routeIndex;
  });

  useEffect(() => {
    if (
      personnelDepartmentRoutes.length > 0 &&
      tabSelected === 0 &&
      !location.pathname.includes(personnelDepartmentRoutes[0]?.path)
    ) {
      history.push(personnelDepartmentRoutes[0].path);
    }
  }, [history, tabSelected, location.pathname, personnelDepartmentRoutes]);

  useEffect(() => {
    // eslint-disable-next-line no-unused-expressions
    !isAuthenticatedFromGDP() &&
      setPersonnelDepartmentRoutes([
        ROUTES.PERSONNEL_DEPARTMENT_OVERVIEW,
        ROUTES.PERSONNEL_DEPARTMENT_MANAGEMENT_PANEL,
        ROUTES.PERSONNEL_DEPARTMENT_SENDING_NOTICES,
        ROUTES.PERSONNEL_DEPARTMENT_PUNCH_CARD_OBSERVATIONS,
      ]);
  }, []);

  const handleTabChange = useCallback(
    (event: React.ChangeEvent<unknown>, newValue: number) => {
      setTabSelected(newValue);
    },
    [],
  );

  const handleTabClick = useCallback(
    (tabItem: RouteItem) => {
      history.push(tabItem.path);
    },
    [history],
  );

  return (
    <>
      <Tabs
        className={classes.tabsContainer}
        value={tabSelected}
        onChange={handleTabChange}
        textColor="inherit"
        indicatorColor="primary"
        variant="scrollable"
        scrollButtons="auto"
      >
        {personnelDepartmentRoutes.map((item, index) => {
          return (
            <Tab
              key={index}
              onClick={() => handleTabClick(item)}
              className={classes.tabContent}
              label={item.title}
            />
          );
        })}
      </Tabs>

      <Switch>
        {!isAuthenticatedFromGDP() && (
          <>
            <Route
              path={ROUTES.PERSONNEL_DEPARTMENT_OVERVIEW.path}
              component={PersonnelDepartmentOverview}
            />
            <Route
              path={ROUTES.PERSONNEL_DEPARTMENT_MANAGEMENT_PANEL.path}
              component={ManagementPanel}
            />
            <Route
              path={ROUTES.PERSONNEL_DEPARTMENT_SENDING_NOTICES.path}
              component={SendingNotices}
            />
            <Route
              path={ROUTES.PERSONNEL_DEPARTMENT_PUNCH_CARD_OBSERVATIONS.path}
              component={PunchCardObservations}
            />
          </>
        )}
      </Switch>
    </>
  );
};

export default PersonnelDepartmentPanelNavigation;
